import { ConcreteEncodable } from "./ConcreteEncodable";

import { AdminImportStatusInfoImplEncoder } from "../../encoder/AdminImportStatusInfoImplEncoder";

import * as CubiqTS from "../../index";
import { AdminImportStatusInfo } from "../AdminImportStatusInfo";

export class AdminImportStatusInfoImpl extends ConcreteEncodable implements AdminImportStatusInfo {
  public static enType: string = "com.bcdfx.model.event.admin.AdminImportStatusInfoImpl";

  /*FID=1*/
  public rowId: number;
  /*FID=2*/
  public payload: string;
  /*FID=3*/
  public status: CubiqTS.AdminImportValidation;
  /*FID=4*/
  public operationType: CubiqTS.AdminModelOperationType;
  /*FID=5*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=10010*/
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AdminImportStatusInfoImplEncoder.Instance;
    this.setEncodableType(AdminImportStatusInfoImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AdminImportStatusInfoImpl[" +
      "rowId=" +
      this.rowId +
      "payload=" +
      this.payload +
      "status=" +
      this.status +
      "operationType=" +
      this.operationType +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "sessionOnly=" +
      this.sessionOnly +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
